export default {
    SPRINT: "sprint",
    TICKETS: "tickets",
    ACCIDENTS: "accidents"
}